import React, { useState, useEffect } from 'react'
import {
  Modal,
  Grid,
  Button,
  FormControl,
  TextField,
  Select,
  MenuItem,
  CircularProgress,
  Box,
} from '@material-ui/core'
import '../../LandingPage/components/LandingActions/LandingActions.scss'

import imageBcie from '../.././../assets/img/image-bcie-3.webp'
// import logoBcie from '../.././../../assets/img/logo-bcie-gtf.png'
import { makeStyles } from '@material-ui/core/styles'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import { useForm } from '../../../context/formContext'
import { createMIPYMEIFI } from '../../../services/IFI/create'
import swal from 'sweetalert'
import ReCAPTCHA from 'react-google-recaptcha'
import { useAuthentication } from '../../../context/authenticationContext'
import SelectReact from 'react-select'
import { getGetUserIfis } from '../../../services/IFI/get'

const useStyles = makeStyles((theme) => ({
  image: {
    backgroundImage: 'url(' + imageBcie + ')',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    [theme.breakpoints.down('xs')]: {
      visibility: 'hidden',
    },
  },
}))

const ModalRegisterMipymes = ({ open, handleClose, handleOpenLogin }) => {
  const { userIDB2C, IdIFIToken, userCountry } = useAuthentication()
  const classes = useStyles()
  const { miPymesType, listCountries } = useForm()
  const [labelIdentificator, setLabelIdentificator] = useState(null)
  const [selectedCountry, setSelectedCountry] = useState('')
  const [loading, setLoading] = useState(false)
  const [captchaIsValid, setCaptchaIsValid] = useState(false)
  const [openModal, setopenModal] = useState(false)
  const [handleMessageCaptcha, setHandleMessageCaptcha] = useState(false)
  const [options, setOptions] = useState([])
  const [selectedPYME, setSelectedPYME] = useState({})
  const [disabled, setDisabled] = useState(false)

  useEffect(() => {
    setSelectedCountry(parseInt(userCountry))
    if (selectedCountry !== '') {
      formik.setFieldValue('taxRegistration', '')
      setLabelIdentificator(
        listCountries.filter(
          (item) => item.IdCountry === parseInt(userCountry),
        ),
      )
    } else {
      formik.setFieldValue('taxRegistration', '')
      setLabelIdentificator(null)
    }
  }, [listCountries])

  const handleCloseModal = () => {
    setopenModal(false)
  }

  const getUserIfi = async () => {
    setopenModal(true)
    try {
      const response = await getGetUserIfis(IdIFIToken)
      if (response.Success) {
        if (response.Data && response.Data.length > 1) {
          const array = []
          let struct
          for (let i = 0; i < response.Data.length; i++) {
            struct = {
              value: response.Data[i],
              label: ` ${response.Data[i].EMail}`,
            }
            array.push(struct)
          }
          if (array.length > 0) {
            setOptions(array)
          } else {
            setOptions([])
          }
        } else {
          setOptions([])
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  const handlePYME = () => {
    formik.setFieldValue('userName', selectedPYME.value.Name)
    formik.setFieldValue('userLastName', selectedPYME.value.LastName)
    formik.setFieldValue('eMail', selectedPYME.value.EMail)
    formik.setFieldValue('isUserNew', false)
    setDisabled(true)
    handleCloseModal()
  }

  const RegisterSchema = Yup.object().shape({
    userName: Yup.string()
      .matches(
        /[\\sa-zA-ZñÑäÄëËïÏöÖüÜáÁéÉíÍóÓúÚ]{0,60}/,
        'El formato del campo es incorrecto',
      )
      .required('Este campo es requerido'),
    userLastName: Yup.string()
      .matches(
        /[\\sa-zA-ZñÑäÄëËïÏöÖüÜáÁéÉíÍóÓúÚ]{0,60}/,
        'El formato del campo es incorrecto',
      )
      .required('Este campo es requerido'),
    idCountry: Yup.number().required('Este campo es requerido'),
    idMiPymeType: Yup.number().required('Este campo es requerido'),
    miPymeBusinessName: Yup.string().required('Este campo es requerido'),
    taxRegistration: Yup.string().required('Este campo es requerido'),
    eMail: Yup.string()
      .email('El formato del email no es válido')
      .required('Este campo es requerido'),
  })

  const formik = useFormik({
    initialValues: {
      userName: '',
      userLastName: '',
      idCountry: parseInt(userCountry),
      idMiPymeType: '',
      taxRegistration: '',
      miPymeBusinessName: '',
      eMail: '',
      IdIFI: IdIFIToken,
      IdUserAzureB2C: userIDB2C,
      isUserNew: true,
    },
    validationSchema: RegisterSchema,
    onSubmit: (values) => {
      if (captchaIsValid) {
        setLoading(true)
        const payload = {
          idCountry: values.idCountry,
          idMiPymeType: values.idMiPymeType,
          taxRegistration: values.taxRegistration,
          miPymeBusinessName: values.miPymeBusinessName,
          eMail: values.eMail,
          userFullName: `${values.userName} ${values.userLastName}`,
          IdIFI: IdIFIToken,
          IdUserAzureB2C: userIDB2C,
          isUserNew: values.isUserNew,
        }
        createMIPYMEIFI(payload)
          .then((res) => {
            if (res.Data.B2CResponse !== null) {
              setLoading(false)

              swal({
                title: `¡Registro exitoso!`,
                text: `Hemos enviado un correo electrónico a la MIPYME con el enlace de acceso a la plataforma.
                `,
                icon: 'success',
                buttons: {
                  catch: {
                    text: 'Continuar',
                    value: 'catch',
                  },
                },
              }).then((value) => {
                switch (value) {
                  case 'catch':
                    close()
                    swal.close()
                    break
                  default:
                    swal.close()
                }
              })
            } else {
              setLoading(false)
              swal({
                title: `¡Error en registro de MIPYME!`,
                text: `${res.Data.InfoProcess.MessageInfo[0].Message}`,
                icon: 'error',
                button: 'Reintentar',
              })
            }
          })

          .catch((err) => {
            setLoading(false)
            swal({
              title: '¡Error!',
              text: 'Ha ocurrido un error al intentar crear la cuenta.',
              icon: 'error',
              button: 'Intentar de nuevo',
            })
            console.log(err)
          })
      } else {
        setHandleMessageCaptcha(true)
      }
    },
  })

  const close = () => {
    setHandleMessageCaptcha(false)
    setCaptchaIsValid(false)
    handleClose()
    formik.resetForm()
    setDisabled(false)
  }

  const onChange = (value) => {
    if (value) {
      setCaptchaIsValid(true)
      setHandleMessageCaptcha(false)
    } else {
      setCaptchaIsValid(false)
    }
  }

  const validationAlert = () => {
    swal({
      title: 'Campos obligatorios',
      text: `Es necesario completar todos los campos del formulario.`,
      icon: 'error',
      button: 'Reintentar',
    })
  }

  const handleSubmitFunction = () => {
    if (!formik.isValid && !captchaIsValid) {
      validationAlert()
    }

    if (!formik.isValid && captchaIsValid) {
      validationAlert()
    }

    if (formik.isValid && !captchaIsValid) {
      validationAlert()
    }
  }

  const getPatternMiPymeId = () => {
    if (parseInt(userCountry) !== null) {
      switch (parseInt(userCountry)) {
        case 1:
          return '[\\0-9]{0,15}'
        case 2:
          return '[sa-zA-ZñÑ0-9]{0,15}'
        case 3:
          return '[0-9]{0,15}'
        case 4:
          return '[sa-zA-ZñÑ0-9]{0,15}'
        case 5:
          return '[0-9]{0,15}'
        case 6:
          return '[sa-zA-ZñÑ0-9]{0,17}'
        case 7:
          return '[0-9]{0,15}'
        default:
          return null
      }
    } else {
      return null
    }
  }

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <form id="register-form" onSubmit={formik.handleSubmit}>
          <div className="modal-content-register">
            <Grid
              container
              spacing={1}
              style={{ fontSize: '18px', fontWeight: '400' }}
            >
              {/* modal mipyme */}
              <Modal
                open={openModal}
                onClose={handleCloseModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box className="modalPYME">
                  <div className="pymeDiv">
                    <h1 className="pymeTitle">Seleccione usuario</h1>
                  </div>
                  <Grid
                    container
                    spacing={1}
                    className="input__container selectPYME"
                  >
                    <Grid item xs={12} sm={12} md={12}>
                      <FormControl style={{ width: '100%' }}>
                        <SelectReact
                          classNamePrefix="select"
                          options={options}
                          placeholder="Escriba el correo de la MIPYME"
                          onChange={(e) => setSelectedPYME(e)}
                          isClearable={true}
                          isSearchable={true}
                        />
                      </FormControl>
                    </Grid>
                    <Grid className="buttonsPYME">
                      <Button
                        className="cancelButton"
                        onClick={() => handleCloseModal()}
                      >
                        Cancelar
                      </Button>
                      <Button
                        className="confirmButton"
                        onClick={() => handlePYME()}
                      >
                        Seleccionar
                      </Button>
                    </Grid>
                  </Grid>
                </Box>
              </Modal>
              <Grid item xs={false} sm={6} md={5} className={classes.image} />
              <Grid item xs={12} sm={6} md={7}>
                <Grid container spacing={1} style={{ padding: '24px 0px' }}>
                  {/* <Grid item xs={12} sm={12} md={12} style={{textAlign: 'center', fontSize: '24px', marginTop: '32px', fontWeight: '500'}}>
                    <img
                      style={{ width: '300px' }}
                      src={logoBcie}
                      alt="React Logo"
                    />
                  </Grid> */}
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    style={{
                      textAlign: 'center',
                      fontSize: '24px',
                      marginTop: '16px',
                      fontWeight: '500',
                    }}
                  >
                    <label>Registro MIPYME</label>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    style={{
                      textAlign: 'center',
                      fontSize: '15px',
                      paddingTop: '0px',
                    }}
                  >
                    <label style={{ color: '#848c95' }}>
                      ¿Ya está registrado?{' '}
                      <span
                        style={{ color: '#004bce', cursor: 'pointer' }}
                        onClick={() => getUserIfi()}
                      >
                        Seleccione usuario
                      </span>
                    </label>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    style={{
                      textAlign: 'center',
                      fontSize: '16px',
                      marginTop: '5px',
                    }}
                  >
                    <label>
                      Complete todos los campos para registrar una MIPYME
                    </label>
                  </Grid>

                  <Grid
                    container
                    spacing={1}
                    className="input-container-register"
                  >
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={6}
                      style={{
                        marginTop: '13px',
                        color: '#848c95',
                        fontWeight: '500',
                        fontSize: '16px',
                      }}
                    >
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        style={{
                          color: '#848c95',
                          fontWeight: '500',
                          fontSize: '16px',
                        }}
                      >
                        <label>
                          Nombre <span style={{ color: 'red' }}>*</span>
                        </label>
                      </Grid>
                      <Grid item xs={12} sm={12} md={12}>
                        <FormControl style={{ width: '100%' }}>
                          <TextField
                            id="userName"
                            style={{ width: '100%' }}
                            error={formik.errors.userName}
                            disabled={disabled}
                            inputProps={{
                              autoComplete: 'off',
                              maxLength: 50,
                              pattern:
                                '[\\sa-zA-ZñÑäÄëËïÏöÖüÜáÁéÉíÍóÓúÚ]{0,60}',
                            }}
                            variant="outlined"
                            value={formik.values.userName}
                            onChange={(e) => {
                              if (e.target.validity.valid) {
                                formik.setFieldValue('userName', e.target.value)
                              }
                            }}
                          />
                        </FormControl>
                      </Grid>
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={6}
                      style={{
                        marginTop: '13px',
                        color: '#848c95',
                        fontWeight: '500',
                        fontSize: '16px',
                      }}
                    >
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        style={{
                          color: '#848c95',
                          fontWeight: '500',
                          fontSize: '16px',
                        }}
                      >
                        <label>
                          Apellido <span style={{ color: 'red' }}>*</span>
                        </label>
                      </Grid>
                      <Grid item xs={12} sm={12} md={12}>
                        <FormControl style={{ width: '100%' }}>
                          <TextField
                            id="userLastName"
                            disabled={disabled}
                            style={{ width: '100%' }}
                            error={formik.errors.userLastName}
                            inputProps={{
                              autoComplete: 'off',
                              maxLength: 60,
                              pattern:
                                '[\\sa-zA-ZñÑäÄëËïÏöÖüÜáÁéÉíÍóÓúÚ]{0,60}',
                            }}
                            variant="outlined"
                            value={formik.values.userLastName}
                            onChange={(e) => {
                              if (e.target.validity.valid) {
                                formik.setFieldValue(
                                  'userLastName',
                                  e.target.value,
                                )
                              }
                            }}
                          />
                        </FormControl>
                      </Grid>
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={6}
                      style={{ marginTop: '5px' }}
                    >
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        style={{
                          color: '#848c95',
                          fontWeight: '500',
                          fontSize: '16px',
                        }}
                      >
                        <label>
                          País <span style={{ color: 'red' }}>*</span>
                        </label>
                      </Grid>
                      <Grid item xs={12} sm={12} md={12}>
                        <FormControl fullWidth>
                          <Select
                            id="country"
                            value={formik.values.idCountry}
                            variant="outlined"
                            onChange={(e) => {
                              setSelectedCountry(e.target.value)
                              formik.setFieldValue('idCountry', e.target.value)
                            }}
                            error={formik.errors.idCountry}
                            disabled
                          >
                            <MenuItem value={''} className="item-mypyme-type">
                              Seleccione una opción
                            </MenuItem>
                            {listCountries &&
                              listCountries.map((item, key) => (
                                <MenuItem
                                  key={key}
                                  value={item.IdCountry}
                                  className="item-mypyme-type"
                                >
                                  {item.LargeName}
                                </MenuItem>
                              ))}
                          </Select>
                        </FormControl>
                      </Grid>
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={6}
                      style={{ marginTop: '5px' }}
                    >
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        style={{
                          color: '#848c95',
                          fontWeight: '500',
                          fontSize: '16px',
                        }}
                      >
                        <label>
                          Tipo MIPYME <span style={{ color: 'red' }}>*</span>
                        </label>
                      </Grid>
                      <Grid item xs={12} sm={12} md={12}>
                        <FormControl fullWidth>
                          <Select
                            id="idMiPymeType"
                            value={formik.values.idMiPymeType}
                            variant="outlined"
                            onChange={(e) => {
                              formik.setFieldValue(
                                'idMiPymeType',
                                e.target.value,
                              )
                            }}
                            error={formik.errors.idMiPymeType}
                          >
                            <MenuItem value={''} className="item-mypyme-type">
                              Seleccione una opción
                            </MenuItem>
                            {miPymesType &&
                              miPymesType.map((item, key) => (
                                <MenuItem
                                  key={key}
                                  value={item.IdMiPymeType}
                                  id={key}
                                  className="item-mypyme-type"
                                >
                                  {item.Description}
                                </MenuItem>
                              ))}
                          </Select>
                        </FormControl>
                      </Grid>
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={12}
                      style={{
                        marginTop: '5px',
                        color: '#848c95',
                        fontWeight: '500',
                        fontSize: '16px',
                      }}
                    >
                      <label>
                        Nombre de la MIPYME{' '}
                        <span style={{ color: 'red' }}>*</span>
                      </label>
                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                      <FormControl style={{ width: '100%' }}>
                        <TextField
                          id="miPymeBusinessName"
                          style={{ width: '100%' }}
                          error={formik.errors.miPymeBusinessName}
                          variant="outlined"
                          value={formik.values.miPymeBusinessName}
                          inputProps={{
                            maxLength: 64,
                            autoComplete: 'off',
                          }}
                          onChange={(e) => {
                            formik.setFieldValue(
                              'miPymeBusinessName',
                              e.target.value,
                            )
                          }}
                        />
                      </FormControl>
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={6}
                      style={{ marginTop: '5px' }}
                    >
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        style={{
                          color: '#848c95',
                          fontWeight: '500',
                          fontSize: '16px',
                        }}
                      >
                        <label>
                          Identificador MIPYME{' '}
                          {labelIdentificator
                            ? `(${labelIdentificator[0]?.LabelIdentification.Denomination})`
                            : null}{' '}
                          <span style={{ color: 'red' }}>*</span>
                        </label>
                      </Grid>
                      <Grid item xs={12} sm={12} md={12}>
                        <FormControl style={{ width: '100%' }}>
                          <TextField
                            id="taxRegistration"
                            style={{ width: '100%' }}
                            error={formik.errors.taxRegistration}
                            inputProps={{
                              autoComplete: 'off',
                              pattern: getPatternMiPymeId(),
                            }}
                            variant="outlined"
                            value={formik.values.taxRegistration}
                            onChange={(e) => {
                              if (e.target.validity.valid) {
                                formik.setFieldValue(
                                  'taxRegistration',
                                  e.target.value,
                                )
                              }
                            }}
                            placeholder={
                              !labelIdentificator ? `Seleccione el país` : ''
                            }
                            disabled={!labelIdentificator}
                          />
                        </FormControl>
                      </Grid>
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={6}
                      style={{ marginTop: '5px' }}
                    >
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        style={{
                          color: '#848c95',
                          fontWeight: '500',
                          fontSize: '16px',
                        }}
                      >
                        <label>
                          Correo Electrónico{' '}
                          <span style={{ color: 'red' }}>*</span>
                        </label>
                      </Grid>
                      <Grid item xs={12} sm={12} md={12}>
                        <FormControl style={{ width: '100%' }}>
                          <TextField
                            id="eMail"
                            style={{ width: '100%' }}
                            error={formik.errors.eMail}
                            inputProps={{
                              autoComplete: 'new-text',
                            }}
                            disabled={disabled}
                            variant="outlined"
                            value={formik.values.eMail}
                            onChange={(e) => {
                              formik.setFieldValue('eMail', e.target.value)
                            }}
                          />
                        </FormControl>
                      </Grid>
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={12}
                      style={{ marginTop: '8px' }}
                    >
                      <ReCAPTCHA
                        sitekey="6Ld2C8MhAAAAAKZqp56Kqo2VseA7QokLq4Tc2zzO"
                        onChange={onChange}
                      />
                      {handleMessageCaptcha ? (
                        <div className="validation-message">
                          Seleccione la casilla para continuar
                        </div>
                      ) : null}
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  container
                  spacing={1}
                  style={{
                    marginTop: '5px',
                    textAlign: 'center',
                    padding: '8px 24px',
                  }}
                  justifyContent="center"
                  direction="row"
                  alignItems="center"
                >
                  <Grid item xs={12} sm={12} md={6}>
                    <Button
                      variant="contained"
                      style={{
                        background:
                          'linear-gradient(135deg, #004bce 11%, #2bce75 100%)',
                        color: 'white',
                        height: '45px',
                        width: '100%',
                      }}
                      type="submit"
                      disabled={loading}
                      onClick={() => {
                        handleSubmitFunction()
                      }}
                    >
                      {loading ? (
                        <CircularProgress size={23} color="white" />
                      ) : (
                        'Registrar'
                      )}
                    </Button>
                  </Grid>
                  <Grid item xs={12} sm={12} md={6}>
                    <Button
                      variant="outlined"
                      style={{ height: '45px', width: '100%' }}
                      onClick={close}
                      disabled={loading}
                    >
                      Cancelar
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </div>
        </form>
      </Modal>
    </>
  )
}

export default React.memo(ModalRegisterMipymes)
